export default __webpack_public_path__ + "static/media/electronics-banner-2.dbae4f65.jpg";